import React from 'react';
import { injectIntl } from 'react-intl';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { SlideTransition } from '../../../components/Transition/Transition';
import WhatsApp from '@mui/icons-material/WhatsApp';
const ECardWelcomeDialog = props => {
  const { intl, open, onClose, from, onSayNo, onSayYes, availableContactMethods, adviserInfo, ...rest } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={false}
      {...rest}
      slots={{
        transition: SlideTransition
      }}
      slotProps={{
        paper: { style: { borderRadius: 12 } }
      }}
    >
      <DialogTitle style={{ textAlign: 'center' }}>
        {intl.formatMessage({ id: 'e-card-welcome-dialog-title' })}
      </DialogTitle>
      <DialogContent>
        <Typography style={{ whiteSpace: 'pre-wrap', textAlign: 'center' }}>
          {intl.formatMessage({ id: 'e-card-welcome-dialog-content' })}
        </Typography>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
          <div style={{ display: 'flex', flexDirection: 'row', gap: 16, marginTop: 16 }}>
            {availableContactMethods.map(method => {
              switch (method.type) {
                case 'whatsapp':
                  if (method.value) {
                    return (
                      <button
                        onClick={method?.onClick}
                        key="whatsapp"
                        variant="contained"
                        color="primary"
                        className="welcome-dialog-btn whatsapp"
                      >
                        <WhatsApp />
                        <span className="title">WhatsApp {intl.formatMessage({ id: 'inquire' })}</span>
                      </button>
                    );
                  }
                  break;
                case 'wechat':
                  if (method.value) {
                    return (
                      <button
                        onClick={method?.onClick}
                        key="wechat"
                        variant="contained"
                        color="primary"
                        className="welcome-dialog-btn wechat"
                      >
                        <img width={24} height={24} alt="" src="img/wechat_transparent.svg" />
                        <span className="title">WeChat {intl.formatMessage({ id: 'inquire' })}</span>
                      </button>
                    );
                  }
                  break;
              }
              return null;
            })}
          </div>
          <span onClick={onClose} style={{ textDecoration: 'underline', cursor: 'pointer' }}>
            {intl.formatMessage({ id: 'e-card-welcome-dialog-dismiss' })}
          </span>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default injectIntl(ECardWelcomeDialog);
